import React, { useState, useEffect } from "react";
import Layout from "../layout/DefaultLayout";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Dropdown,
  Spinner,
  InputGroup,
  Form,
} from "react-bootstrap";
import { IoSearch } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";
import { FaEllipsisV, FaPlus } from "react-icons/fa";
import api from "../utils/helper";
import { useMutation, useQuery, useQueryClient } from "react-query";
import Footer from "../components/Footer";
import { URLS } from "../utils/URL";
import { useAlerts } from "../context/AlertContext";
import Delete from "../components/Delete";

const Vendor = () => {
  const [vendorToDelete, setVendorToDelete] = useState(null);
  const [vendorNameToDelete, setVendorNameToDelete] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useAlerts();
  const [showDelete, setShowDelete] = useState();

  // Debounce the search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const { data, isLoading, error } = useQuery(
    ["vendors", debouncedSearchTerm],
    () =>
      api
        .get(
          `/super-admin/vendors${
            searchTerm ? `?search=${debouncedSearchTerm}` : ""
          }`
        )
        .then((res) => {
          console.log("API Response:", res.data);
          return res.data.data;
        }),
    {
      enabled: true,
    }
  );

  const vendors = data || [];
  console.log(vendors, "vendors");

  const handleAddVendor = () => {
    navigate("/add-vendor", { state: { isEdit: false, vendorData: null } });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const deleteMutation = useMutation(
    (vendorID) => api.delete(`/super-admin/vendor/${vendorID}`),
    {
      onSuccess: (response) => {
        showSuccess(response.data?.message || "Deleted successfully!");
        console.log("Deleted successfully!", response);
        queryClient.invalidateQueries("vendors");
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Failed to deleted: ");
        console.log("Failed to deleted: " + error.message);
      },
    }
  );

  const handleDelete = (id, vendorName) => {
    // Store the ID to be deleted
    setVendorToDelete(id);
    setVendorNameToDelete(vendorName);
    setShowDelete(true);
  };

  const handleExport = () => {
    console.log("report execute");
    // Construct the URL with the existing search parameter if any
    const exportUrl = `/super-admin/vendors?downloadCSV=true&csvFields=vendor.name,vendor.email,vendor.location${
      debouncedSearchTerm ? `&search=${debouncedSearchTerm}` : ""
    }`;

    // Call the API with the download flag
    api
      .get(exportUrl, { responseType: "blob" })
      .then((response) => {
        // Create a blob URL from the response data
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Create a temporary anchor element
        const link = document.createElement("a");
        link.href = url;

        // Set the file name (you can adjust this based on your API response)
        link.setAttribute("download", "vendors.csv");

        // Append to the document, click it, and then remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke the blob URL to free up memory
        window.URL.revokeObjectURL(url);

        showSuccess("Vendors list exported successfully!");
      })
      .catch((error) => {
        showError(error?.response?.data?.message || "Failed to export vendors");
        console.error("Export error:", error);
      });
  };

  return (
    <Layout>
      <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h2 className="heading text-light px-3 mb-0">Vendors</h2>
          <Badge pill className="header-badge mx-2">
            {vendors?.length} Vendors
          </Badge>
        </div>
        <div className="d-flex justify-content-between px-2 mt-3">
          <div className="input-group me-2" style={{ maxWidth: "150px" }}>
            <span className="input-group-text bg-light border-secondary-subtle">
              <IoSearch color="#344054" size={12} />
            </span>
            <input
              type="text"
              className="form-control border-secondary-subtle"
              placeholder="Search..."
              aria-label="Search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          <Button
            variant="light"
            className="me-2 btn-sec btn-new"
            onClick={handleExport}
          >
            <FiDownload color="#344054" size={16} className="me-2" /> Export
          </Button>
          <Button
            color="#60B1FF"
            onClick={handleAddVendor}
            className="btn-sec btn-new"
            style={{ border: "none" }}
          >
            <FaPlus size={10} className="me-2" /> Add New
          </Button>
        </div>
      </div>
      <Container
        fluid
        className="main-container vendor-container mt-0 mt-md-4 ps-auto ps-md-0"
      >
        {/* Header Section */}
        <Card className="main-card vendorList">
          <Card.Header className="heading d-none d-lg-block">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2 align-items-center">
                <h2 className="venhead mb-0">Vendors</h2>
                <Badge pill className="header-badge">
                  {vendors?.length} Vendors
                </Badge>
              </div>
              <div className="d-flex align-items-center">
                <div className="input-group me-3" style={{ maxWidth: "150px" }}>
                  <InputGroup.Text className="bg-light border-secondary-subtle">
                    <IoSearch color="#344054" size={16} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    className="border-secondary-subtle"
                    placeholder="Search vendors..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </div>
                <Button
                  variant="outline-secondary"
                  className="me-2 btn-sec"
                  onClick={handleExport}
                >
                  <FiDownload color="#344054" size={16} /> Export
                </Button>
                <Button
                  color="#60B1FF"
                  onClick={handleAddVendor}
                  className="btn-sec"
                >
                  <FaPlus size={16} /> Add New
                </Button>
              </div>
            </div>
          </Card.Header>

          {isLoading ? (
            <div className="text-center">
              <Spinner size="md" />
            </div>
          ) : (
            <Card.Body>
              {vendors.length === 0 ? (
                <div className="text-center ">
                  <p className="text-muted fs-5">No vendors found.</p>
                </div>
              ) : (
                <Row className="g-3">
                  {vendors
                    .slice()
                    .reverse()
                    .map(
                      ({
                        vendor,
                        totalStudents,
                        totalTeachers,
                        approvedCourses,
                      }) =>
                        vendor && (
                          <Col md={4} key={vendor._id}>
                            <Card className="shadow-sm h-100">
                              <Card.Body>
                                <div className="d-flex align-items-top justify-content-between">
                                  <div>
                                    <img
                                      src={
                                        vendor.profile_img
                                          ? URLS.IMG_URL + vendor.profile_img
                                          : "/images/bajajLogo.png"
                                      }
                                      alt="Vendor Logo"
                                      className="img-fluid mb-2"
                                      width={57}
                                      height={35}
                                    />
                                    <Card.Title className="vendor-title ">
                                      {vendor.name}
                                    </Card.Title>
                                  </div>
                                  <div className="">
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        id="dropdown-basic"
                                        className="menu-course-add"
                                      >
                                        <FaEllipsisV
                                          size={18}
                                          color="#98A2B3"
                                          className=""
                                        />
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu className="c-menu">
                                        <Dropdown.Item
                                          onClick={() =>
                                            navigate("/add-vendor", {
                                              state: {
                                                vendorData: vendor,
                                                isEdit: true,
                                              },
                                            })
                                          }
                                        >
                                          Edit
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          onClick={() =>
                                            handleDelete(
                                              vendor._id,
                                              vendor.name
                                            )
                                          }
                                        >
                                          Delete
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </div>
                                {/* <hr /> */}
                                <div className="d-flex justify-content-between">
                                  <div className="p-0">
                                    <p className="mb-0 textpara">Students</p>
                                    <h6 className="mb-0 textnum">
                                      {totalStudents}
                                    </h6>
                                  </div>
                                  <div className="p-0">
                                    <p className="mb-0 textpara">Teachers</p>
                                    <h6 className="mb-0 textnum">
                                      {totalTeachers}
                                    </h6>
                                  </div>
                                  <div className="p-0">
                                    <p className="mb-0 textpara">
                                      Active Courses
                                    </p>
                                    <h6 className="mb-0 textnum">
                                      {approvedCourses}
                                    </h6>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        )
                    )}
                </Row>
              )}
            </Card.Body>
          )}
        </Card>
      </Container>
      <div className="d-none d-lg-block">
        <Footer />
      </div>
      <Delete
        show={showDelete}
        close={() => setShowDelete(false)}
        handleDelete={() => {
          deleteMutation.mutate(vendorToDelete);
          setShowDelete(false);
        }}
        title="Delete Vendor"
        name={vendorNameToDelete}
      />
    </Layout>
  );
};

export default Vendor;
